import * as React from 'react';
import { Team } from '../../../sdk/model';
import { FormControl, InputLabel, Select, MenuItem, useMediaQuery, useTheme } from '@mui/material';

interface tradeOptionsMenuProps {
  handleTradeProposalChange: Function,
  asset: object,
  teamId: string,
  myTeam: boolean,
  otherTeamIds: Array<string | undefined>,
  teamMap: Map<string | undefined, Team | undefined>,
  value: string,
  droppable: boolean,
  disabled: boolean
}

function TradeOptionsMenu(props: tradeOptionsMenuProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [value, setValue] = React.useState(props.value);
  const [otherTeamIds, setOtherTeamIds] = React.useState(props.otherTeamIds);
  
  React.useEffect(() => {
    if (props.value !== value) {
      setValue(props.value);
    }
  }, [props.value]);
  
  React.useEffect(() => {
    if (props.otherTeamIds !== otherTeamIds) {
      setOtherTeamIds(props.otherTeamIds);
    }
  }, [props.otherTeamIds]);
  
  function handleChange(assetId: string, fromTeamId: string, value: string) {
    setValue(value);
    props.handleTradeProposalChange(assetId, fromTeamId, value);
  }

  return (
    <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>
      <InputLabel id="trade-options-label">Action</InputLabel>
      <Select
        labelId="trade-options-label"
        value={value}
        label="Action"
        disabled={props.disabled}
        onChange={(e) => handleChange(props.asset.id, props.teamId, e.target.value)}
        sx={{
          '& .MuiSelect-select': {
            padding: isMobile ? '8px 12px' : '16px',
            minHeight: isMobile ? '40px' : 'auto',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: isMobile ? '60vh' : 'none',
              marginTop: isMobile ? '8px' : '4px',
            },
          },
          MenuListProps: {
            dense: isMobile,
          },
        }}
      >
        <MenuItem value="default" dense={isMobile}>
          <em>Select an action</em>
        </MenuItem>
        {props.myTeam && props.droppable && (
          <MenuItem value="drop" dense={isMobile}>
            {isMobile ? 'Drop' : 'Drop Player'}
          </MenuItem>
        )}
        {otherTeamIds.filter(Boolean).map((otherTeamId) => {
          const otherTeam = props.teamMap.get(otherTeamId);
          const teamName = otherTeam?.name || 'Unknown Team';
          return (
            <MenuItem key={otherTeamId} value={otherTeamId} dense={isMobile}>
              {isMobile ? teamName : `Trade to ${teamName}`}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  )
}

export default TradeOptionsMenu;